document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.menu-drawer__menu-item').forEach(item => {
    item.addEventListener('touchstart', function() {
      this.style.background = 'rgba(168, 85, 247, 0.08)';
      const text = this.querySelector('.menu-drawer__menu-item-text');
      if (text) text.style.color = 'rgba(200, 160, 255, 0.95)';
    });
    item.addEventListener('touchend', function() {
      setTimeout(() => {
        this.style.background = '';
        const text = this.querySelector('.menu-drawer__menu-item-text');
        if (text) text.style.color = '';
      }, 300);
    });
  });
});